import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static values = { top: { type: String, default: '0' } }

  initialize = () => {
    this.prevPageYOffset = window.pageYOffset
    this.topHeight = this.element.getBoundingClientRect().height
  }

  connect = () => {
    this.showTop()
    on('scroll', this.scrolled)
    on('resize', this.showTop)
  }

  disconnect = () => {
    off('scroll', this.scrolled)
    off('resize', this.showTop)
  }

  scrolled = () => {
    const pageYOffset = window.pageYOffset

    if (pageYOffset < screen.height) return

    if (this.prevPageYOffset > pageYOffset) {
      this.showTop()
    }
    else {
      this.hideTop()
    }

    this.prevPageYOffset = pageYOffset
  }

  showTop = () => {
    this.element.style.top = this.topValue
  }

  hideTop = () => {
    this.element.style.top = `-${this.topHeight}px`
  }
}
